(function () {
  function init() {
    var bar = document.querySelector('[data-product-sticky-bar]');
    if (!bar) return;

    document.body.appendChild(bar);

    if ('MutationObserver' in window) {
      var keepLastObserver = new MutationObserver(function () {
        if (document.body.lastElementChild !== bar) {
          document.body.appendChild(bar);
        }
      });
      keepLastObserver.observe(document.body, { childList: true });
    }

    var realForm = document.querySelector('form[data-type="add-to-cart-form"]');
    var realSubmit = realForm && realForm.querySelector('.product-form__submit');
    if (!realForm || !realSubmit) return;

    // Only present when the product has a single variant: no size drawer to
    // open, so the button submits the real form directly (see main-product.liquid).
    var addBtn = bar.querySelector('[data-product-sticky-bar-add]');
    var variantPicker = document.querySelector('variant-radios, variant-selects');

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (realSubmit.disabled || realSubmit.getAttribute('aria-disabled') === 'true') {
          if (variantPicker) {
            variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            variantPicker.classList.add('product-sticky-bar__highlight');
            setTimeout(function () {
              variantPicker.classList.remove('product-sticky-bar__highlight');
            }, 1500);
          }
          return;
        }
        realSubmit.click();
      });
    }

    var realTitle = document.querySelector('.product__title h1');

    function isAnyModalOpen() {
      // Judge.me uses different modal markup per form: the ask-a-question
      // modal is a `.jdgm-modal-block`, but the write-a-review modal has no
      // such class (just `.jdgm-write-review-modal`) and no shared `.jdgm-modal`
      // ancestor either. Match anything with both "jdgm" and "modal" in its
      // class list so future Judge.me modal variants are covered too.
      var modals = document.querySelectorAll('[class*="jdgm"][class*="modal"], dialog[open], [class*="modal"][open]');
      for (var i = 0; i < modals.length; i++) {
        if (modals[i].getBoundingClientRect().height > 0) return true;
      }
      return false;
    }

    if ('IntersectionObserver' in window) {
      var intersecting = {};

      function updateVisibility() {
        var anyRealContentVisible = Object.keys(intersecting).some(function (key) {
          return intersecting[key];
        });
        bar.classList.toggle('is-visible', !anyRealContentVisible && !isAnyModalOpen());
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var key = entry.target === realSubmit ? 'submit' : 'title';
            intersecting[key] = entry.isIntersecting;
          });
          updateVisibility();
        },
        { threshold: 0 }
      );
      observer.observe(realSubmit);
      if (realTitle) observer.observe(realTitle);

      // Poll for third-party modals (Judge.me, etc.) opening/closing instead of
      // a MutationObserver on document.body: the bar itself lives in body and
      // toggling its own class would immediately re-trigger such an observer,
      // fighting with updateVisibility() and leaving the bar stuck hidden.
      var lastModalOpen = isAnyModalOpen();
      setInterval(function () {
        var modalOpen = isAnyModalOpen();
        if (modalOpen !== lastModalOpen) {
          lastModalOpen = modalOpen;
          updateVisibility();
        }
      }, 300);
    } else {
      bar.classList.add('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
